import { TASK_CATEGORY_CODES, TASK_CATEGORY_SYSTEM } from '@liza/fhir-utils';
import type { CodeSystem, CodeSystemConcept } from '@medplum/fhirtypes';

/**
 * The clinical domain of a care-plan item Task — `clinical`, `food`, `movement`, … Written as a
 * coding on `Task.code.coding[]`; the single source of the code list is `TASK_CATEGORY_CODES` in
 * `@liza/fhir-utils`, so the CodeSystem cannot drift from what the app writes and reads.
 *
 * Replaces the legacy `input` entry keyed by the bare string `liza-task-category`, which was never a
 * URI and never had a CodeSystem behind it (see the 2026-08-31 Task data-integrity decision).
 */
const DISPLAY: Record<(typeof TASK_CATEGORY_CODES)[number], string> = {
  clinical: 'Clinical',
  food: 'Food',
  measurement: 'Measurement',
  medication: 'Medication',
  mind: 'Mind',
  movement: 'Movement',
  other: 'Other',
  sleep: 'Sleep',
};

const CONCEPTS: CodeSystemConcept[] = TASK_CATEGORY_CODES.map((code) => ({ code, display: DISPLAY[code] }));

export const taskCategoryCodeSystem: CodeSystem = {
  resourceType: 'CodeSystem',
  url: TASK_CATEGORY_SYSTEM,
  name: 'task-category',
  title: 'Liza Task Category',
  // Mirror the canonical URL as an identifier so `deployResources` converges by identifier, not name.
  identifier: [{ system: 'urn:ietf:rfc:3986', value: TASK_CATEGORY_SYSTEM }],
  status: 'active',
  content: 'complete',
  concept: CONCEPTS,
};
